import { Component, OnInit, inject } from '@angular/core';
import { ReactiveFormsModule, FormControl } from '@angular/forms';
// import { RecaptchaComponent } from 'ng-recaptcha';
import { IMail } from '../../common/IMail.interface';
import { MailService } from '../../services/mail.service';
import { faEnvelope, faPhone, faHome } from '@fortawesome/free-solid-svg-icons';
import { faFacebook, faTwitter, faGooglePlus } from '@fortawesome/free-brands-svg-icons';
import { GoogleMapsModule } from '@angular/google-maps';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CallApiService } from '../../services/api-action.service';
import { AsyncClickDirective } from '../../directives/async-click.directive';
import { EMPTY, Observable, tap } from 'rxjs';

@Component({
    imports: [ReactiveFormsModule, GoogleMapsModule, FontAwesomeModule, AsyncClickDirective],
    selector: 'app-contact',
    templateUrl: './contact.component.html',
    styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit {
  private mailService = inject(MailService);
  private apiActionService = inject(CallApiService);

  ngOnInit(): void {
    this.markers.push({
      position: {
        lat: this.center.lat,
        lng: this.center.lng,
      },
      icon: {
        path: google.maps.SymbolPath.CIRCLE,
        scale: 10,
      },
      title: 'GetLocal GmbH',
      info: 'GetLocal GmbH',
      options: {
        animation: google.maps.Animation.DROP,
      },
    });
  }

  // @ViewChild('recaptchaRef') recaptchaRef: RecaptchaComponent | undefined;

  faHome = faHome;
  faPhone = faPhone;
  faEnvelope = faEnvelope;
  faFacebook = faFacebook;
  faTwitter = faTwitter;
  faGooglePlus = faGooglePlus;

  display: any;
  center: google.maps.LatLngLiteral = {
    lat: 51.4645347,
    lng: 6.8496955,
  };
  zoom = 10;
  zoomlevel: number = 10;
  markers = [] as any;

  emailName = new FormControl('');
  emailSubject = new FormControl('');
  emailAddress = new FormControl('');
  emailMessage = new FormControl('');
  isResolved: boolean = false;

  send(): Observable<unknown> {
    if (
      this.emailAddress.errors ||
      this.emailMessage.errors ||
      this.emailName.errors ||
      this.emailSubject.errors
    ) {
      return EMPTY;
    }
    const mail: IMail = {
      address: this.emailAddress.value,
      message: this.emailMessage.value,
      name: this.emailName.value,
      subject: this.emailSubject.value,
    };

    return this.apiActionService
      .callWithToasts$(
        this.mailService.sendMail(mail),
        $localize`Die E-Mail wurde erfolgreich versendet.`,
        $localize`Die E-Mail konnte nicht versandt werden.`
      )
      .pipe(
        tap(() => {
          this.cleanFields();
          // this.recaptchaRef!.reset();
          this.isResolved = false;
        })
      );
  }

  cleanFields() {
    this.emailName.setValue('');
    this.emailName.reset();

    this.emailSubject.setValue('');
    this.emailSubject.reset();

    this.emailAddress.setValue('');
    this.emailAddress.reset();

    this.emailMessage.setValue('');
    this.emailMessage.reset();
  }

  resolved(_captchaResponse: string) {
    this.isResolved = true;
  }

  moveMap(event: google.maps.MapMouseEvent) {
    if (event.latLng != null) this.center = event.latLng.toJSON();
  }
  move(event: google.maps.MapMouseEvent) {
    if (event.latLng != null) this.display = event.latLng.toJSON();
  }
}
